/* Performance batch 2 (B3, Oct 2026): /service, Login and Register load only when visited (AppMain.js). When one
   of them is opened directly, its code starts downloading here, at the very beginning, at the same time as the
   rest of the app, instead of after it. Only dynamic import() calls, so nothing is added to other pages. */
const PAGES = {
  '/service': () => import('@/pages/public/ServiceLanding'),
  '/login': () => import('@/pages/auth/LoginPage'),
  '/register': () => import('@/pages/auth/RegisterPage'),
};

export function startPublicEarly(pathname) {
  const p = (pathname || '/').replace(/\/+$/, '') || '/';
  const load = PAGES[p];
  if (load) { try { load().catch(() => {}); } catch { /* the page loads normally */ } }
}
